import React, { useState } from 'react';
import { Table, Button, Form, Row, Col, Card } from 'react-bootstrap';
import { FaPlus, FaSave, FaTimes, FaTrash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';

const OPCOES_TIPO = [
  { value: 'V', label: 'Venda' },
  { value: 'C', label: 'Comissão' },
  { value: 'R', label: 'Rescisão' },
];

const labelTipo = (val) => {
  const opt = OPCOES_TIPO.find((o) => o.value === val);
  return opt != null ? opt.label : val;
};

const emptyForm = { tipo: 'V', ge: '', cre: '', deb: '', cc: '', perc: '', ge_inter: '', cre_inter: '', deb_inter: '', cc_inter: '', ge_inter2: '', cre_inter2: '', deb_inter2: '', cc_inter2: '' };

const GridLanctoAdm = ({ codigoFamilia, lancamentos, onRecarregar }) => {
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(emptyForm);
  const [salvando, setSalvando] = useState(false);

  const handleAbrirForm = () => {
    setForm(emptyForm);
    setShowForm(true);
  };

  const setField = (name, value) => setForm((prev) => ({ ...prev, [name]: value }));

  const handleIncluir = async () => {
    if (!form.tipo) {
      toast.warn('Selecione o tipo do lançamento');
      return;
    }
    setSalvando(true);
    try {
      await api.incluirLanctoAdmConfig({
        codigo_familia: codigoFamilia,
        tipo: form.tipo,
        ge: form.ge !== '' ? Number(form.ge) : null,
        cre: form.cre !== '' ? Number(form.cre) : null,
        deb: form.deb !== '' ? Number(form.deb) : null,
        cc: form.cc !== '' ? Number(form.cc) : null,
        perc: form.perc !== '' ? Number(form.perc) : null,
        ge_inter: form.ge_inter !== '' ? Number(form.ge_inter) : null,
        cre_inter: form.cre_inter !== '' ? Number(form.cre_inter) : null,
        deb_inter: form.deb_inter !== '' ? Number(form.deb_inter) : null,
        cc_inter: form.cc_inter !== '' ? Number(form.cc_inter) : null,
        ge_inter2: form.ge_inter2 !== '' ? Number(form.ge_inter2) : null,
        cre_inter2: form.cre_inter2 !== '' ? Number(form.cre_inter2) : null,
        deb_inter2: form.deb_inter2 !== '' ? Number(form.deb_inter2) : null,
        cc_inter2: form.cc_inter2 !== '' ? Number(form.cc_inter2) : null,
      });
      toast.success('Lançamento incluído com sucesso!');
      setShowForm(false);
      onRecarregar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao incluir lançamento';
      toast.error(msg);
    } finally {
      setSalvando(false);
    }
  };

  const handleExcluir = async (item) => {
    if (!window.confirm(`Excluir lançamento seq ${item.seq}?`)) return;
    try {
      await api.excluirLanctoAdmConfig({
        codigo_familia: codigoFamilia,
        seq: item.seq,
      });
      toast.success('Lançamento excluído!');
      onRecarregar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao excluir lançamento';
      toast.error(msg);
    }
  };

  const NumInput = ({ name, label, md }) => (
    <Col md={md || 2}>
      <Form.Group>
        <Form.Label className="small mb-1">{label}</Form.Label>
        <Form.Control type="number" value={form[name]} onChange={(e) => setField(name, e.target.value)} />
      </Form.Group>
    </Col>
  );

  return (
    <Card className="mb-3">
      <Card.Header className="d-flex justify-content-between align-items-center py-2">
        <strong>Lançamentos Administrativos</strong>
        <Button size="sm" variant="outline-primary" onClick={handleAbrirForm}>
          <FaPlus className="mr-1" /> Incluir
        </Button>
      </Card.Header>
      <Card.Body className="p-0">
        {showForm && (
          <div className="p-3 border-bottom bg-light">
            <Row>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Tipo</Form.Label>
                  <Form.Control as="select" value={form.tipo} onChange={(e) => setField('tipo', e.target.value)}>
                    {OPCOES_TIPO.map((o) => (
                      <option key={o.value} value={o.value}>{o.label}</option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <NumInput name="ge" label="GE" />
              <NumInput name="cre" label="Cre" />
              <NumInput name="deb" label="Deb" />
              <NumInput name="cc" label="CC" />
              <NumInput name="perc" label="%" />
            </Row>
            <Row className="mt-2">
              <Col md={12}><small className="text-muted font-weight-bold">Inter-empresa</small></Col>
              <NumInput name="ge_inter" label="GE Inter" />
              <NumInput name="cre_inter" label="Cre Inter" />
              <NumInput name="deb_inter" label="Deb Inter" />
              <NumInput name="cc_inter" label="CC Inter" />
            </Row>
            <Row className="mt-2">
              <Col md={12}><small className="text-muted font-weight-bold">Inter-empresa 2</small></Col>
              <NumInput name="ge_inter2" label="GE Inter2" />
              <NumInput name="cre_inter2" label="Cre Inter2" />
              <NumInput name="deb_inter2" label="Deb Inter2" />
              <NumInput name="cc_inter2" label="CC Inter2" />
            </Row>
            <div className="mt-2">
              <Button size="sm" variant="success" className="mr-2" onClick={handleIncluir} disabled={salvando}>
                <FaSave className="mr-1" /> Salvar
              </Button>
              <Button size="sm" variant="secondary" onClick={() => setShowForm(false)} disabled={salvando}>
                <FaTimes className="mr-1" /> Cancelar
              </Button>
            </div>
          </div>
        )}
        <div style={{ maxHeight: 300, overflow: 'auto' }}>
          <Table striped bordered hover size="sm" className="mb-0" style={{ minWidth: 1100 }}>
            <thead>
              <tr>
                <th>Seq</th>
                <th>Tipo</th>
                <th>GE</th>
                <th>Cre</th>
                <th>Deb</th>
                <th>CC</th>
                <th>%</th>
                <th>GE Int.</th>
                <th>Cre Int.</th>
                <th>Deb Int.</th>
                <th>CC Int.</th>
                <th>GE Int2</th>
                <th>Cre Int2</th>
                <th>Deb Int2</th>
                <th>CC Int2</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {lancamentos.length === 0 && (
                <tr>
                  <td colSpan={16} className="text-center text-muted">
                    Nenhum lançamento cadastrado
                  </td>
                </tr>
              )}
              {lancamentos.map((item) => (
                <tr key={item.seq}>
                  <td>{item.seq}</td>
                  <td>{labelTipo(item.tipo)}</td>
                  <td>{item.ge}</td>
                  <td>{item.cre}</td>
                  <td>{item.deb}</td>
                  <td>{item.cc}</td>
                  <td>{item.perc}</td>
                  <td>{item.ge_inter}</td>
                  <td>{item.cre_inter}</td>
                  <td>{item.deb_inter}</td>
                  <td>{item.cc_inter}</td>
                  <td>{item.ge_inter2}</td>
                  <td>{item.cre_inter2}</td>
                  <td>{item.deb_inter2}</td>
                  <td>{item.cc_inter2}</td>
                  <td>
                    <Button size="sm" variant="outline-danger" title="Excluir" onClick={() => handleExcluir(item)}>
                      <FaTrash />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default GridLanctoAdm;
